// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.img-container {
  display: block;
  height: auto;
  padding: 0 15px;
  margin-left: auto;
  margin-right: auto;
}

.form-group-button {
  padding: 25px 0px;
}

label {
  margin: 10px 0 10px 0;
}

.wc-container .wc-container-in .sucursalLabel {
  text-align: justify;
}
.wc-container .wc-container-in .principal-title {
  text-align: left;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
